export const AUTOMATED_ANALYSIS_ERRORS = {
  NO_AUDIO: 'Video has no audio',
  SMALL_WORD_COUNT: 'Word count too small',
};

export const SMALL_WORD_COUNT_ERROR_TEXT = t(
  'automated_analysis.grading_station.fewer_than_ten_words',
);

export const RESULTS_UNAVAILABLE_ERROR_TEXT = t(
  'automated_analysis.grading_station.results_unavailable',
);

export const TRANSCRIPT_UNABLE_TO_PROCESS_ERROR_TEXT = t(
  'automated_analysis.grading_station.transcript.unable_to_process',
);

export const TRANSCRIPT_NONE = t(
  'automated_analysis.grading_station.transcript.none',
);

export const TRANSCRIPT_SYSTEM_ISSUE_ENCOUNTERED_ERROR_TEXT = t(
  'automated_analysis.grading_station.transcript.analysis_failed',
);
